import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  private loadingSubject = new BehaviorSubject<boolean>(false);
  loading$ = this.loadingSubject.asObservable();
  private activeRequests = 0;
  private loaderTimeout: any;
  show() {
    this.activeRequests++;
    if (this.activeRequests === 1) {
      // Add a tiny delay to prevent flicker
      this.loaderTimeout = setTimeout(() => this.loadingSubject.next(true), 50);
    }
  }

  hide() {
    if (this.activeRequests > 0) this.activeRequests--;

    if (this.activeRequests === 0) {
      clearTimeout(this.loaderTimeout); // cancel pending show
      // Optional: small delay before hiding
      setTimeout(() => this.loadingSubject.next(false), 50);
    }
  }
}